module.exports = __webpack_public_path__ + "img/IMG_0533.b9f14576.png";